import { Button } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useState } from 'react'

import { BODY_PARTS, REASON_CHARS_MINIMUM } from '../../../constants'

import { useProtocol } from '../../../hooks/useProtocol'
import { useParams } from 'react-router-dom'
import { BodyPartSelector, VERTICAL } from '../move/BodyPartSelector'
import { getPreviousPhaseUtil } from '../../../util/subject-journey'
import { useMoveSubjectBack } from '../../../hooks/useSubject'
import { FormLabel } from '../../../components/form/FormLabel'

type MovePreviousProps = {
  subjectData: any
  onClose: () => void
}

export const MovePreviousDrawer = ({ subjectData, onClose }: MovePreviousProps) => {
  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }

  const { callMoveBack, isLoading } = useMoveSubjectBack(projectId, subjectId)

  const [selectedBodyParts, setSelectedBodyParts] = useState<string>()
  const [moveBackReason, setMoveBackReason] = useState<string>('')
  const [reasonError, setReasonError] = useState<string | null>(null)
  const [bodyPartsError, setBodyPartsError] = useState<string | null>(null)

  const { data: protocolData } = useProtocol(projectId)
  const phasesData = protocolData.phases

  /**
   *
   * THis is legacy code from the old version of the Modals - Needs cleanup
   *
   */
  const sortedPhases = phasesData
    .slice() // make a shallow copy to avoid mutating the original array
    .sort((a, b) => a.order - b.order) // sort by real 'order', we do this cuz otherwise it will be by creation in db

  const previousPhase = getPreviousPhaseUtil(sortedPhases, subjectData)

  const handleMoveBack = () => {
    // If there are body parts options available but no option has been chosen -> set error and leave
    if (plainOptions.length > 0 && !selectedBodyParts) {
      setBodyPartsError('Please select a body part')
      return
    }

    // If the number of characters in the reason text field is less than the required minimum  -> set error and leave
    if (moveBackReason.length < REASON_CHARS_MINIMUM) {
      setReasonError(`Please provide a reason minimum ${REASON_CHARS_MINIMUM} characters long`)
      return
    }

    const obj = {
      subjectId: subjectData._id,
      bodyPart: selectedBodyParts,
      projectId: projectId,
      reasonDescription: moveBackReason,
    }

    return callMoveBack(obj)
      .then((result) => {
        onClose()
        return result
      })
      .catch((error) => {
        console.error('Error moving subject forward:', error)
      })
  }

  const plainOptions = previousPhase.bodyParts
    ? previousPhase.bodyParts.map((item) => {
        return { bodyPart: item, label: BODY_PARTS[item] || item }
      })
    : []

  //const hasReason = moveBackReason.length < 5 ? false : true

  // const canMove = selectedBodyParts !== undefined && hasReason

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setReasonError(null)
    setMoveBackReason(e.target.value)
  }

  const handleSelectBodyPartChange = (bodyPart: string) => {
    setBodyPartsError(null)
    setSelectedBodyParts(bodyPart)
  }

  return (
    <div className="row">
      <div className="col-12">
        <h5>Move Participant to Previous Phase</h5>
        <p className="mt-3">
          Revert the participant to the previous phase. The subject will answer the questionnaire set up for that phase.
        </p>
        <p className="mt-3 opacity-75">Please, provide a written reason for the revert action:</p>
      </div>

      {previousPhase?.bodyParts?.length > 0 ? (
        <div className="col-12">
          <BodyPartSelector
            className="row mt-5"
            bodyparts={plainOptions}
            setSelectedBodyPart={handleSelectBodyPartChange}
            direction={VERTICAL}
          />
          <p className="p-small text-danger" style={{ marginTop: '-8px' }}>
            {bodyPartsError || '\u00A0'}
          </p>
        </div>
      ) : null}

      <div className="col-12 mt-3">
        <FormLabel label="Please provide a reason"></FormLabel>
        <TextArea placeholder="" rows={2} className="mt-1" onChange={handleTextChange} />
      </div>
      <div className="col-12">
        <p className="p-small text-danger">{reasonError || '\u00A0'}</p>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <Button onClick={onClose} type="default" className="me-2">
          Cancel
        </Button>

        <Button onClick={handleMoveBack} loading={isLoading} type="primary">
          Confirm move
        </Button>
      </div>
    </div>
  )
}
